import { PlusOutlined, QuestionCircleOutlined, SyncOutlined } from "@ant-design/icons";
import { getTagList } from "@axios/api.account";
import { TagProps } from "@axios/models";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import {
  Avatar,
  Breadcrumb,
  Button,
  Cascader,
  Col,
  ConfigProvider,
  Dropdown,
  Empty,
  Form,
  FormInstance,
  Input,
  Menu,
  Modal,
  Pagination,
  Progress,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
  notification
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
import {
  addAndroidApp,
  addAppStoreByAppId,
  appStoreGroup,
  deleteAndroidApp,
  getAppStoreGroup,
  getAppStoreSearchList,
  getIosApps,
  iosApplicationStrategy,
  pushIosInstallApp,
  refushApp,
  updateAppStatus
} from "../../axios/api.app";
import { CancelTokenSource } from "../../axios/axios.core";
import { RootStoreModel } from "../../redux/reducers";
import { gaEvent } from "../../withTracker";
import { BasicStateForListModel } from "../models";
import { PushAppForm } from "./app.push";

import i18n from "@src/locales";
import en_US from "antd/es/locale/en_US";
import zh_CN from "antd/es/locale/zh_CN";
import { t } from "i18next";
import { Translation } from "react-i18next";
import TextArea from "antd/lib/input/TextArea";

interface stateModel extends BasicStateForListModel {
  appFormRef: FormInstance<any> | null;
  isDeviceModalvisible: boolean;
  search: string;
  searchPlatform: string | undefined;
  deviceType: string;
  syncLoding: boolean,
  isPushModalvisible: boolean,
  selectAppId: string;
  pushAppInfo: object,
  appTypeVisible: boolean,
  applyPeople: string
  tags: any[],
  tableColumns: any[],
  strategyModalVisible: boolean,
  initChangeManagedApp: string,
  initAutoUpgrade: string,
  addAppModalVisible:boolean,
  appSearchList:any[],
  selectArea:string,
  selectDeviceType:string,
  initPreference:string,
  preferenceContent:string
}

interface propsModel extends RouteComponentProps<any, any, any> {
  tokenSuccess: boolean,
  orgOptions: treeNode[],
}

const mapStatetoProps = (state: RootStoreModel) => ({
  tokenSuccess: state.userState.tokenSuccess,
  orgOptions: getOrgsOptionsSelector(state),
});

class AppStorePage extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  timeout:ReturnType<typeof setTimeout> | null= null;
  currentValue: string =""

  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      appFormRef: React.createRef<FormInstance>().current,
      isDeviceModalvisible: false,
      search: "",
      searchPlatform: undefined,
      deviceType: "",
      syncLoding: false,
      isPushModalvisible: false,
      selectAppId: "",
      pushAppInfo: {},
      appTypeVisible: false,
      applyPeople: "",
      tags: [],
      tableColumns: [],
      strategyModalVisible: false,
      initChangeManagedApp: "0",
      initAutoUpgrade: "0",
      addAppModalVisible:false,
      appSearchList:[
      ],
      selectArea:"CN",
      selectDeviceType: "software",
      initPreference: "0",
      preferenceContent: ""
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    console.log("i18n.language ",i18n.language )
    if (this.props.tokenSuccess) {
      this.getList();
      this.getTasks();
    }
    this.setState({
      tableColumns: [
        {
          title: '',
          dataIndex: 'iconUrl',
          key: 'iconUrl',
          align: 'center',
          render: (v:any) => (
            <Avatar
              shape="square"
              size={68}
              src={v}
              alt=""
            />
          )
        },
        {
          title: '应用名称',
          dataIndex: 'name',
          key: 'name',
        },
   
        {
          title: 'Bundle Id',
          dataIndex: 'packageName',
          key: 'packageName',
        },
        {
          title: '平台',
          dataIndex: 'deviceFamilies',
          key: 'deviceFamilies',
          render: (v: any, row: any) => {
            return this.getDeviceFamiliesStr(row.deviceFamilies);
          }
        },
        {
          title: '来源',
          dataIndex: 'source',
          key: 'source'
        },
        {
          title: '安装设备',
          dataIndex: 'deviceCount',
          key: 'deviceCount',
          filterDropdown: true,
          filterIcon: (
            <Tooltip title={t("显示已安装此应用的设备，包含通过MDM安装和用户自行安装的")}>
              <QuestionCircleOutlined />
            </Tooltip>
          ),
          align: "center",
          render: (v: any, row: any) => {
            return (
              <NavLink to={{ 
                pathname: `/home/apps/installDetail`, 
                state: { 
                  "isDevice": true,
                  "isAppStore": true,
                  "platform": this.getDeviceFamiliesStr(row.deviceFamilies), 
                  "packageName": row.packageName, 
                  "logoUrl": row.iconUrl, 
                  "name": row.name, 
                  "versionNumber": row.version, 
                  "appSize": row.displaySize 
                } 
              }}>{v}</NavLink>
            )
          }
        },
        {
          title: '安装明细',
          dataIndex: 'installCount',
          key: 'installCount',
          filterDropdown: true,
          filterIcon: (
            <Tooltip title={t("显示通过MDM成功触发安装应用指令的设备具体状态，仅支持iOS16以上并开启声明式管理的设备并且操作InstallApp成功")}>
              <QuestionCircleOutlined />
            </Tooltip>
          ),
          align: "center",
          render: (v: any, row: any) => {
            return (
              <NavLink to={{ 
                pathname: `/home/apps/installDetail`, 
                state: { 
                  "isDevice": false,
                  "isAppStore": true,
                  "platform": this.getDeviceFamiliesStr(row.deviceFamilies), 
                  "packageName": row.packageName, 
                  "logoUrl": row.iconUrl, 
                  "name": row.name, 
                  "versionNumber": row.version, 
                  "appSize": row.displaySize,
                  "id": row.adamId  
                } 
              }}>
                {`${row.installSuccessCount} / ${v}`}
              </NavLink>
            )
          }
        },
        // {
        //   title: '价格',
        //   dataIndex: 'displayPrice',
        //   key: 'displayPrice',
        //   render: (v: any) => v=="免费"?t("免费"): v
        // },
        {
          title: '应用许可',
          dataIndex: 'adamId',
          key: 'adamId',
          filterDropdown: true,
          filterIcon: (
            <Tooltip title={t("显示应用许可分发的数量，与ABM/ASM保持一致，应用通过MDM分发并卸载会自动移除许可")}>
              <QuestionCircleOutlined />
            </Tooltip>
          ),
          render: (v: any, row: any) => {
            return (
              <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                <Progress percent={row.assignedCount * 100 / row.totalCount} size="small" format={() => row.assignedCount + "/" + row.totalCount} showInfo={false}/>
                <span>{row.assignedCount + "/" + row.totalCount}</span>
              </div>
            )
          }
        },
        {
          title: '操作',
          dataIndex: 'adamId',
          key: 'adamId',
          align: 'center',
          render: (v: any, row: any) => {
            return (
              <Translation>{t => {
                return (
                  <Dropdown dropdownRender={() => (
                    <Menu>
                      <Menu.Item key="strategy">
                        <a className="ft-15" onClick={() => {
                          this.setState({ 
                            strategyModalVisible: true, 
                            selectAppId: row.adamId,
                            initChangeManagedApp: row.changeManagedApp ? "1" : "0",
                            initAutoUpgrade: row.autoUpgrade ? "1" : "0",
                            initPreference: row.isPreference ? "1" : "0",
                            preferenceContent: row.preferenceContent
                          });
                          gaEvent("appStore", "onClick", "应用策略");
                        }}>
                          {t("应用策略")}
                        </a>
                      </Menu.Item>
                      
                      
                      <Menu.Item key="send" >
                        <a className="ft-15" onClick={() => {
                          this.setState({ isPushModalvisible: true, selectAppId: row.adamId, applyPeople: "" });
                          gaEvent("appStore", "onClick", "推送")
                        }}>{t("推送")}</a>
                      </Menu.Item>
                      {/* <Menu.Item key="detail">
                        <NavLink to={{ 
                          pathname: `/home/apps/installDetail`, 
                          state: { 
                            "isDevice": false,
                            "isAppStore": true,
                            "platform": this.getDeviceFamiliesStr(row.deviceFamilies), 
                            "packageName": row.packageName, 
                            "logoUrl": row.iconUrl, 
                            "name": row.name, 
                            "versionNumber": row.version, 
                            "appSize": row.displaySize,
                            "id": row.adamId 
                          } 
                        }}>{t("安装明细")}</NavLink></Menu.Item> */}
                      <Menu.Item key="service" onClick={() => { this.getAppSelfService(row.adamId) }}>{t("自助服务")}</Menu.Item>
                      <Menu.Item key="open" onClick={() => { window.open(row.url); gaEvent("appStore", "onClick", "{windowOpen") }}>{t("在App Store查看")}</Menu.Item>
                    </Menu>
                  )}>
                    <a>{t("更多")}</a>
                  </Dropdown>
                )
              }}</Translation>
            );
          }
        },
      ]
    })
  }
  getTasks = () => {
    getTagList().then((res) => {
      var dat = this.formatOptions(res)
      console.log("formatOptions", dat);
      this.setState({ tags: dat })
    })
  }
  formatOptions = (tags: TagProps[]) => {
    return tags.map(({ id, key, values }) => {
      return {
        value: id,
        label: key,
        children: values.map((item: any) => ({
          value: item.id,
          label: item.value,
        })),
      };
    });
  }
  componentDidUpdate(prevProps: propsModel) {
    if (this.props.tokenSuccess != prevProps.tokenSuccess) {
      this.getList();
      this.getTasks();
    }
  }
  updateAppStatusClick = (appId: string, status: string) => {

    this.setState({ loading: true });
    updateAppStatus(appId, status == "Active" ? "Disabled" : "Active").then((res) => {
      this.setState({ loading: false })
      this.getList();
    });
  };

  componentWillUnmount() {

    this.cancelToken.cancel("cancel axios http request");
  }

  onSearch = () => {
    this.getList(1);
  };

  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize

  ) => {
    const { search, searchPlatform, deviceType} = this.state;
    this.setState({ loading: true });
    getIosApps({
      pageIndex,
      pageSize,
      searchName: search,
      deviceType: deviceType,
      flag: searchPlatform == "-1" ? null : searchPlatform
    }).then((res) => {
      const { dataList } = res;
      this.setState({
        data: dataList.map((item, i) => ({ ...item, key: i })),
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        loading: false,
        totalCount: res.totalCount,
      });
    });
  };
  getDeviceFamiliesStr(de: any[]) {
    var str = "";
    if (de == null) {
      return "";
    }
    for (var i = 0; i < de.length; i++) {
      str +=de[i]
      str += "/"
      // if (de[i] == "iphone" || de[i] == "ipad" || de[i] == "mac") {
      //   str += de[i] == "iphone" ? "iPhone" : de[i] == "ipad" ? "iPad" : de[i];
      //   str += "/"
      // }
    }
    str = str.substring(0, str.length - 1);
    return str;
  }
  applyGroupOk = () => {
    this.setState({ loading: true })
    this.formRef?.current?.validateFields().then((res) => {
      // if (!res.type) {
      //   this.setState({loading: false})
      //   return notification.warning({message: "未选择适用人群"})
      // }
      var arg: any = {pushType: res.type || 'None'};
      // if (this.state.applyPeople == "Organization") {
      //   arg.organizationIds = [];
      //   arg.organizationIds.push(res.Organization);
      // }
      if (this.state.applyPeople == "Tag") {
        arg.tagValueIds = [];
        res.tags.forEach((item: any) => {
          arg.tagValueIds.push(item.tag[1]);
        });
      }
      appStoreGroup(this.state.selectAppId, arg).then(c => {
        notification.success({ message: <Translation>{t => {return t("成功")}}</Translation> })
        this.setState({ loading: false, appTypeVisible: false, applyPeople: "" })
      }, () => {
        this.setState({ loading: false })
        notification.error({ message: <Translation>{t => {return t("失败")}}</Translation> })
      })

    })

  }
  onOk = () => {
    this.state.appFormRef?.validateFields().then(
      (res) => {
        console.log(res);
        const { name, versionNumber, description, logo, appPackage } = res;

        this.setState({ loading: true });
        addAndroidApp({
          name,
          versionNumber,
          description,
          logo: logo[0]?.originFileObj,
          appPackage: appPackage[0]?.originFileObj,
        }).then(
          () => {
            notification.success({ message: <Translation>{t => {return t("添加成功")}}</Translation> });
            this.setState(
              { loading: false, isDeviceModalvisible: false },
              () => {
                this.state.appFormRef?.resetFields();
              }
            );
            this.getList(1);
          },
          () => this.setState({ loading: false })
        );
      },
      () => { }
    );
  };

  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteAndroidApp(id).then(
      () => {
        notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
        this.setState({ loading: false });
        this.getList(1);
      },
      () => this.setState({ loading: false })
    );
  };
  refushApp = () => {
    this.setState({ syncLoding: true })
    refushApp().then(() => {
      notification.success({ message: <Translation>{t => {return t("更新成功")}}</Translation> });
      this.getList();
      this.setState({ syncLoding: false })
    }, () => {
      notification.success({ message: <Translation>{t => {return t("更新失败")}}</Translation> });
      this.setState({ syncLoding: false })
    })

  }

  getAppSelfService = (id: string) => {
    this.setState({loading: true});
    getAppStoreGroup(id).then(
      res => {
        // 先渲染出模态框
        this.setState({ appTypeVisible: true, selectAppId: id, applyPeople: res.pushType });
        // 再更新formRef
        this.formRef.current?.setFieldsValue({
          type: res.pushType,
          Organization: res.organizationIds[0],
          tags: res.tags
        });
      },
      () => {
        notification.error({message: <Translation>{t => {return t("获取自助服务失败")}}</Translation>});
      }
    ).finally(
      () => {
        this.setState({loading: false});
      }
    )
  }

  onStrategyOk = () => {
    this.formRef.current?.validateFields().then((res) => {
      var form = {
        "changeManagedApp": res.changeManagedApp === "1" ? true : false,
        "autoUpgrade": res.autoUpgrade === "1" ? true : false,
        "isPreference": res.isPreference === "1" ? true : false,
        "preferenceContent": res.preferenceContent
      }

      iosApplicationStrategy(this.state.selectAppId, form).then(() => {
        notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>});
        this.formRef.current?.resetFields();
        this.setState({strategyModalVisible: false});
        this.getList();
      }).finally(() => {
        this.setState({loading: false})
      })
    })
    
  }
  fetch = (value: string, callback: (data:any) => void) => {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout =null;
    }
    const fake = () => {
    this.currentValue = value;
      getAppStoreSearchList({country:this.state.selectArea,name:value,entity:this.state.selectDeviceType}).then(res=>{
        if (this.currentValue === value) {
          callback(res)
        }
      })
    };
    if (value) {
      this.timeout = setTimeout(fake, 300);
    } else {
      callback([]);
    }
  }
  handleAppNameSearch = (newValue: string) => {

    this.fetch(newValue, this.updateAppSearchList);

  };
  selectAreaChange = (newValue: string) => {
    this.setState({selectArea:newValue})
  };
  selectDeviceTypeChange = (newValue: string) => {
    this.setState({selectDeviceType:newValue})
  };
  updateAppSearchList=(data:any)=>{
    console.log("updateAppSearchList",data)
    this.setState({appSearchList:data})
  }
  addAppStoreClick=()=>{
    this.formRef.current?.validateFields().then((res) => {
      addAppStoreByAppId(res.appId,this.state.selectArea).then(res=>{
        this.setState({ 
          appSearchList: [],
          addAppModalVisible:false
        });
        
        notification.success({message: <Translation>{t => {return t("添加应用成功")}}</Translation>});
        this.formRef.current?.resetFields();
        this.getList();
      }).catch(()=>{
        notification.error({message: <Translation>{t => {return t("添加应用失败")}}</Translation>});
      })
    })
  }

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      addAppModalVisible,
      search,
      searchPlatform,
      deviceType,
      syncLoding,
      isPushModalvisible,
      selectAppId,
      pushAppInfo,
      appTypeVisible,
      applyPeople,
      tags,
      tableColumns,
      strategyModalVisible,
      initChangeManagedApp,
      initAutoUpgrade,
      initPreference,
      preferenceContent,
      appSearchList
    } = this.state;
    const { orgOptions } = this.props;
    // console.log(columns)
    return (
      (<Translation>{t => {
          return (
            (<div>
              <div className="breadcrumbTop py-2">
                <Breadcrumb>
                  <Breadcrumb.Item>{t("应用库")}</Breadcrumb.Item>
                  <Breadcrumb.Item>App Store</Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{padding: "32px 0 11px 0"}}>
                    <Space>
                        <img src="/images/appstoreIcon.svg" alt="" />
                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>App Store</span>
                    </Space>
                </Row>
              </div>
              <Spin spinning={loading}>
                <Row style={{ width: "100%" }}>
                  <div className="borderBox">
                    <Row className="mb-3" gutter={[20, 10]}>
                      <Col>
                        {t("应用名称")}:
                        <Input
                          placeholder={t("输入应用名称")}
                          value={search}
                          style={{ width: "220px", marginLeft: 10 }}
                          onChange={(e) => this.setState({ search: e.target.value })}
                        ></Input>
                      </Col>
                      <Col>
                        {t("类型")}:
                        <Select
                          value={searchPlatform}
                          style={{ width: "200px", marginLeft: 10 }}
                          onChange={(v) => this.setState({ searchPlatform: v })}
                          allowClear
                          placeholder={t("全部")}>
                          <Select.Option value="-1">{t("全部")}</Select.Option>
                          <Select.Option value="0">Custom</Select.Option>
                          <Select.Option value="1">Free</Select.Option>
                          <Select.Option value="2">Paid</Select.Option>
                        </Select>
                      </Col>
                      <Col>
                        {t("平台")}:
                        <Select
                          value={deviceType}
                          style={{ width: "200px", marginLeft: 10 }}
                          onChange={(v) => this.setState({ deviceType: v })}
                          allowClear
                          placeholder={t("全部")}
                        >
                          <Select.Option value="">{t("全部")}</Select.Option>
                          <Select.Option value="Phone">iOS</Select.Option>
                          <Select.Option value="Pad">iPad</Select.Option>
                          <Select.Option value="PC">macOS</Select.Option>
                        </Select>
                      </Col>
                      <Col>
                        <Button type="primary" onClick={this.onSearch}>
                          {t("查询")}
                        </Button>
                      </Col>
                    </Row>
                  </div>
                  <div className="borderBox">
                    <Row>
                      {/* <Col>
                          <Radio.Group value={tableType} onChange={(e)=>{this.setState({tableType:e.target.value});this.getList(1,10,e.target.value=='Vpp')}}>
                            <Radio.Button value="Vpp">Vpp</Radio.Button>
                            <Radio.Button value="AppStore">AppStore</Radio.Button>
                          </Radio.Group>
                      </Col> */}
                      <Col className="ms-auto" style={{  }}>
                        <Space>
                          <Button
                            style={{ width: "160px" ,padding:0}}
                            type="primary"
                            onClick={() => { this.setState({addAppModalVisible:true}) }}
                          >
                              <span style={{lineHeight:"32px"}}> <PlusOutlined style={{marginRight:12}}/>{t("App Store添加")}</span>
                          </Button>
                          <Button
                            style={{ width: "160px",padding:0}}
                            type="primary"
                            ghost
                            loading={syncLoding}
                            onClick={() => { this.refushApp(); gaEvent("appStore", "onClick", "refushApp") }}>
                            <span style={{lineHeight:"32px"}}> <SyncOutlined style={{marginRight:12}}/>{t("同步VPP")}</span>
                           
                          </Button>
                        </Space>
                      </Col>
                    </Row>
                    <Row>
                      {data.length > 0 && (
                        <Table
                          size="middle"
                          style={{width: "100%"}}
                          loading={loading}
                          dataSource={data}
                          pagination={false}
                          // onChange={this.onTableChange}
                          rowKey={record => record.id}
                          columns={tableColumns.map((item)=>{ 
                            item.title = t(item.title)
                            return item 
                          })}
                          // rowSelection={this.rowSelection()}
                          locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        ></Table>
                      )}
                    </Row>
                    {data.length <= 0 && (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>
                    )}
                    <ConfigProvider locale={i18n.language === "zh" ? zh_CN : en_US}>
                      <Pagination
                        style={{ textAlign: "right", marginTop: "20px" }}
                        pageSize={pageSize}
                        current={pageIndex}
                        total={totalCount}
                        showTotal={(total, range) =>
                          `${range[0]}-${range[1]} / ${total} ${t("条")}`
                        }
                        onChange={(page, pageSize) => {
                          this.setState({ pageIndex: page, pageSize: pageSize ? pageSize : 0 })
                          this.getList(page, pageSize);
                        }}
                        showTitle={false}
                        onShowSizeChange={(current, size) => this.getList(current, size)}
                      ></Pagination>
                    </ConfigProvider>
                  </div>
                </Row>
              </Spin>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={appTypeVisible}
                destroyOnClose={false}
                title={t("自助服务")}
                width={"650px"}
                onOk={() => {
                  this.applyGroupOk()
                }}
                onCancel={() => {
                  this.setState({ appTypeVisible: false, applyPeople: "" })
                  this.formRef.current?.resetFields()
                }}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Form style={{ width: "90%", marginTop: 36 }}
                  layout="horizontal"
                  ref={this.formRef}
                  // labelCol={{ span: 3 }}
                  initialValues={{ type: "None" }}>
                  {/* <Form.Item label="应用分类" name="status" rules={[{ required: false }]} >
                    <Select>
                      <Select.Option value="1">效率</Select.Option>
                    </Select>

                  </Form.Item> */}
                  <Form.Item label={t("适用人群")} name="type" rules={[{ required: false }]} >
                    <Select allowClear placeholder={t("未选择")} onChange={(e) => {
                      this.setState({ applyPeople: e + "" })
                      this.formRef.current?.setFieldsValue({
                        Organization: [],
                        tags: []
                      })
                    }}>
                      <Select.Option value="None">{t("未选择")}</Select.Option>
                      <Select.Option value="All">{t("全部")}</Select.Option>
                      {/* <Select.Option value="Organization">{t("部门")}</Select.Option> */}
                      <Select.Option value="Tag">{t("设备组")}</Select.Option>
                    </Select>
                  </Form.Item>
                  {/* {applyPeople == "Organization" && (
                    <Form.Item label={t("选择部门")} name="Organization" rules={[{ required: false }]} >
                      <TreeSelect treeData={orgOptions} treeDefaultExpandAll></TreeSelect>
                    </Form.Item>
                  )} */}
                  {applyPeople == "Tag" && (
                    <Form.List name="tags">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map((field) => (
                            <Form.Item key={field.key} labelCol={{ span: 3 }} label={t("设备组")}>
                              <Row justify="space-between">
                                <Col span="21">
                                  <Form.Item noStyle
                                    {...field}
                                    name={[field.name, "tag"]}
                                    // fieldKey={[field.fieldKey, "tag"]}
                                  >
                                    <Cascader options={tags} />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Button type="dashed" onClick={() => { remove(field.name); gaEvent("deviceAdd", "onClick", "remove") }}>-</Button>
                                </Col>
                              </Row>
                            </Form.Item>
                          ))}
                          <Form.Item wrapperCol={{ offset: 3 }}>
                            <Button type="dashed" onClick={() => { add(); gaEvent("deviceAdd", "onClick", "add") }} block>
                              {t("添加设备组")}
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  )}
                </Form>
              </Modal>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={isPushModalvisible}
                destroyOnClose={true}
                title={t("推送应用")}
                width={"650px"}
                onOk={() => {
                  this.setState({ loading: true });
                  pushIosInstallApp(selectAppId, this.state.pushAppInfo).then(
                    () => {
                      notification.success({ message: t("推送成功") });
                      this.setState(
                        { loading: false, isPushModalvisible: false },
                        () => {
                          this.state.appFormRef?.resetFields();
                        }
                      );
                    },
                    () => this.setState({ loading: false })
                  );
                }}
                onCancel={() => {
                  this.setState({ isPushModalvisible: false, loading: false });
                  this.setState({ pushAppInfo: {} })
                }}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <PushAppForm
                  appId={selectAppId}
                  onLoad={(ref) => {
                    this.setState({ pushAppInfo: ref })
                  }}
                ></PushAppForm>
              </Modal>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={strategyModalVisible}
                destroyOnClose={true}
                title={t("应用策略")}
                width={"650px"}
                onOk={() => { this.onStrategyOk() }}
                onCancel={() => {
                  this.setState({ 
                    strategyModalVisible: false, 
                    loading: false 
                  });
                  this.formRef.current?.resetFields();
                }}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Form 
                  style={{ width: "90%", marginTop: 36 }}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  layout="horizontal"
                  ref={this.formRef}
                  initialValues={{
                    changeManagedApp: initChangeManagedApp, 
                    autoUpgrade: initAutoUpgrade,
                    isPreference: initPreference,
                    preferenceContent: preferenceContent
                  }}
                >
                  <Form.Item label={t("更改为受管理应用")} name="changeManagedApp">
                    <Select>
                      <Select.Option value="1">{t("是")}</Select.Option>
                      <Select.Option value="0">{t("否")}</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item label={t("自动强制应用升级")} name="autoUpgrade"> 
                    <Select>
                      <Select.Option value="1">{t("是")}</Select.Option>
                      <Select.Option value="0">{t("否")}</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item label={t("偏好设置")} name="isPreference">
                    <Select onChange={(e) => { this.setState({initPreference: e}) }} >
                      <Select.Option value="1">{t("是")}</Select.Option>
                      <Select.Option value="0">{t("否")}</Select.Option>
                    </Select>
                  </Form.Item>
                  {initPreference == "1" && 
                  <Form.Item name="preferenceContent" wrapperCol={{ offset: 8, span: 16 }}>
                    <TextArea showCount rows={5}  maxLength={1000} />
                  </Form.Item>}
                </Form>
              </Modal>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={addAppModalVisible}
                destroyOnClose={true}
                title={t("添加应用")}
                width={"650px"}
                onOk={() => { this.addAppStoreClick() }}
                onCancel={() => {
                  this.setState({ 
                    addAppModalVisible: false,
                    appSearchList:[]
                  });
                  this.formRef.current?.resetFields();
                }}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Form 
                  style={{ width: "90%", marginTop: 36 }}
                  layout="horizontal"
                  ref={this.formRef}
                  labelCol={{ span: 5 }}
                  initialValues={{
                    area: "CN",
                    deviceType: "software"
                  }}
                >
                  <Form.Item label={t("区域")} name="area">
                  <Select
                      showSearch
                      placeholder="Select a country"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={this.selectAreaChange}
                      options={ (i18n.language === "zh")?
                        [
                          {value: "US", label: "美国"},
                          {value: "CA", label: "加拿大"},
                          {value: "GB", label: "英国"},
                          {value: "AU", label: "澳大利亚"},
                          {value: "FR", label: "法国"},
                          {value: "DE", label: "德国"},
                          {value: "JP", label: "日本"},
                          {value: "CN", label: "中国"},
                          {value: "IT", label: "意大利"},
                          {value: "ES", label: "西班牙"},
                          {value: "BR", label: "巴西"},
                          {value: "RU", label: "俄罗斯"},
                          {value: "IN", label: "印度"},
                          {value: "MX", label: "墨西哥"},
                          {value: "KR", label: "韩国"},
                          {value: "AR", label: "阿根廷"},
                          {value: "AT", label: "奥地利"},
                          {value: "BE", label: "比利时"},
                          {value: "CL", label: "智利"},
                          {value: "CO", label: "哥伦比亚"},
                          {value: "CZ", label: "捷克"},
                          {value: "DK", label: "丹麦"},
                          {value: "FI", label: "芬兰"},
                          {value: "GR", label: "希腊"},
                          {value: "HK", label: "香港"},
                          {value: "HU", label: "匈牙利"},
                          {value: "ID", label: "印度尼西亚"},
                          {value: "IE", label: "爱尔兰"},
                          {value: "IL", label: "以色列"},
                          {value: "MY", label: "马来西亚"},
                          {value: "NL", label: "荷兰"},
                          {value: "NZ", label: "新西兰"},
                          {value: "NO", label: "挪威"},
                          {value: "PE", label: "秘鲁"},
                          {value: "PH", label: "菲律宾"},
                          {value: "PL", label: "波兰"},
                          {value: "PT", label: "葡萄牙"},
                          {value: "SA", label: "沙特阿拉伯"},
                          {value: "SE", label: "瑞典"},
                          {value: "SG", label: "新加坡"},
                          {value: "TH", label: "泰国"},
                          {value: "TR", label: "土耳其"},
                          {value: "TW", label: "台湾"},
                          {value: "UA", label: "乌克兰"},
                          {value: "VE", label: "委内瑞拉"},
                          {value: "ZA", label: "南非"}
                      ]:
                      [
                        {value: "US", label: "United States"},
                        {value: "CA", label: "Canada"},
                        {value: "GB", label: "United Kingdom"},
                        {value: "AU", label: "Australia"},
                        {value: "FR", label: "France"},
                        {value: "DE", label: "Germany"},
                        {value: "JP", label: "Japan"},
                        {value: "CN", label: "China"},
                        {value: "IT", label: "Italy"},
                        {value: "ES", label: "Spain"},
                        {value: "BR", label: "Brazil"},
                        {value: "RU", label: "Russia"},
                        {value: "IN", label: "India"},
                        {value: "MX", label: "Mexico"},
                        {value: "KR", label: "South Korea"},
                        {value: "AR", label: "Argentina"},
                        {value: "AT", label: "Austria"},
                        {value: "BE", label: "Belgium"},
                        {value: "CL", label: "Chile"},
                        {value: "CO", label: "Colombia"},
                        {value: "CZ", label: "Czech Republic"},
                        {value: "DK", label: "Denmark"},
                        {value: "FI", label: "Finland"},
                        {value: "GR", label: "Greece"},
                        {value: "HK", label: "Hong Kong"},
                        {value: "HU", label: "Hungary"},
                        {value: "ID", label: "Indonesia"},
                        {value: "IE", label: "Ireland"},
                        {value: "IL", label: "Israel"},
                        {value: "MY", label: "Malaysia"},
                        {value: "NL", label: "Netherlands"},
                        {value: "NZ", label: "New Zealand"},
                        {value: "NO", label: "Norway"},
                        {value: "PE", label: "Peru"},
                        {value: "PH", label: "Philippines"},
                        {value: "PL", label: "Poland"},
                        {value: "PT", label: "Portugal"},
                        {value: "SA", label: "Saudi Arabia"},
                        {value: "SE", label: "Sweden"},
                        {value: "SG", label: "Singapore"},
                        {value: "TH", label: "Thailand"},
                        {value: "TR", label: "Turkey"},
                        {value: "TW", label: "Taiwan"},
                        {value: "UA", label: "Ukraine"},
                        {value: "VE", label: "Venezuela"},
                        {value: "ZA", label: "South Africa"}
                    ]}
                    />
                  </Form.Item>
                  <Form.Item label={t("设备类型")} name="deviceType">
                  <Select
                      showSearch
                      placeholder="Select a device type"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={this.selectDeviceTypeChange}
                      options={
                        [
                          {value: "software", label: "iPhone"},
                          {value: "iPadSoftware", label: "iPad"},
                          {value: "desktopSoftware", label: "Mac"}
                        ]}
                    />
                  </Form.Item>
                  <Form.Item label={t("应用名称")} name="appId">
                  <Select
                    showSearch
                    placeholder={t("请输入应用名称")}
                    onSearch={this.handleAppNameSearch}
                    notFoundContent={null}
                    showArrow={false}
                    defaultActiveFirstOption={false}
                    filterOption={false}
                    optionLabelProp="label"
                  >
                    {appSearchList.map((appItem:any)=>(
                      <Select.Option value={appItem.appId} label={appItem.name}>
                        <div style={{display:"flex"}}>
                          <div style={{flexGrow:1}}>
                            <img style={{height:66,flexGrow:1}} src={appItem.iconUrl}></img>
                          </div>
                          <div  style={{flexGrow:10,fontSize:12,lineHeight:"22px"}}>
                            <div><span style={{fontSize:16,fontWeight:500}}>{appItem.name}</span></div>
                            <div><span style={{fontSize:14,fontWeight:500}}>{t("类别")}:</span>{appItem.genres?.join(",")}</div>
                            <div><span style={{fontSize:14,fontWeight:500}}> {t("支持的设备")}:</span>{appItem.platforms?.join(",")}</div>
                          </div>
                        </div>
                    
                    
                      </Select.Option>
                      ))}
                  </Select>
                  </Form.Item>
                </Form>
              </Modal>
            </div>)
          );
        }}</Translation>)
    );
  }
}

export default connect(mapStatetoProps, {})(AppStorePage);
